import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import OfflineTooltip from 'components/OfflineTooltip';
import SidebarAvailableShiftLink from 'components/ScheduleSidebar/SidebarAvailableShiftLink';
import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import EmployeeActions from 'actions/EmployeeActions.js';
import Popover from 'components/popover/Popover.js';
import Backdrop from 'components/Backdrop.js';

class SidebarAvailableShifts extends React.Component {
  constructor(props) {
    super(props);

    this.selectedLocation = null;
    this.selectedShiftID = null;
    this.selectedReplyShiftID = null;
    this.selectedTarget = null;
   
    

    this.onShiftOfferSentSuccessfully = this.onShiftOfferSentSuccessfully.bind(this);
    this.onShiftOfferCanceledSuccessfully = this.onShiftOfferCanceledSuccessfully.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onAvailabilitiesDetailClick = this.onAvailabilitiesDetailClick.bind(this);
    this.onShiftOfferSentError = this.onShiftOfferSentError.bind(this);
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this.onRequestClicked = this.onRequestClicked.bind(this);
    this.onCancelRequestClicked = this.onCancelRequestClicked.bind(this);
    this.onDeclineClicked = this.onDeclineClicked.bind(this);
    this.onShiftOfferDeclinedSuccessfully = this.onShiftOfferDeclinedSuccessfully.bind(this);

    this.state = {
      hasReplies: null,
      declined: false,
      callOut: false,
      selectedDepartmentID: null,
      selectedLocationID: null,
      selectedPosition: null,
      selectedJobSiteName: null,
      selectedJobSiteAddress: null,
      notes: null,
      shift_breaks: null,
      popOverActive: false,
      popTarget: null,
      popOverCancelDisabled: '',
      popOverRequestDisabled: '',
      popoverData: {
        title: null,
        time: null,
      },
      requestError: false,
    };
  }

  componentDidMount() {
    if (this.props.selectedShift) {
      this.onAvailabilitiesDetailClick({}, this.props.selectedShift);
    }

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  componentWillUnmount() {
    OffersStore.off('offer:reply:success', this.onShiftOfferSentSuccessfully);
    OffersStore.off('offer:cancel:success', this.onShiftOfferCanceledSuccessfully);
    OffersStore.off('offer:decline:success', this.onShiftOfferDeclinedSuccessfully);
    OffersStore.off('offer:reply:error offer:cancel:error offer:decline:error', this.onShiftOfferSentError);
    this.selectedShiftID = null;
    this.selectedReplyShiftID = null;
    this.selectedTarget = null;

    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _onClosePopover() {
    this.setState({
      popOverActive: false,
      popTarget: null,
    });
    this.resetPopover();
  }

  onShiftOfferSentError(error) {
    document.querySelector('p#error-text').innerHTML = JSON.parse(error.responseText).error_message;
    
    Utils.removeSpinner();
    if(error) {
      this.setState({
        requestError: true,
      });
    }
  }

  resetPopover() {
    document.querySelector('span#shift-departments').innerHTML = '';
    this.selectedTarget = null;
    this.selectedShiftID = null;
    this.selectedReplyShiftID = null;
    document.querySelector('p#error-text').innerHTML = '';
    this.setState({
      popoverData: {
        title: null,
        time: null,
      },
      requestError: false,
    });

    OffersStore.off('offer:reply:success', this.onShiftOfferSentSuccessfully);
    OffersStore.off('offer:cancel:success', this.onShiftOfferCanceledSuccessfully);
    OffersStore.off('offer:decline:success', this.onShiftOfferDeclinedSuccessfully);
    OffersStore.off('offer:reply:error offer:cancel:error offer:decline:error', this.onShiftOfferSentError);

    Utils.removeSpinner();
  }

  onShiftOfferSentSuccessfully(data, response) {
    this.resetPopover();
    this.onCancelClicked();
  }

  onShiftOfferCanceledSuccessfully(data, response) {
    this.resetPopover();
    this.onCancelClicked();
  }

  onShiftOfferDeclinedSuccessfully() {
    this.resetPopover();
    this.onCancelClicked();
  }

  onDeclineClicked() {
    if (this.selectedShiftID != null) {
      Utils.replaceElementWithSpinner(
        document.querySelector('.popoveravailabilities .popover__content'),
      );
      this.setState({ popOverCancelDisabled: 'disabled' });
      EmployeeActions.declineShift(this.selectedShiftID);
    }
  }

  // Declining is a call-out's thing: a plain available shift is requested or left alone,
  // as it always was, and the API refuses a decline on one.
  canDecline() {
    return this.state.callOut;
  }

  onRequestClicked(e) {
    if (this.selectedShiftID != null) {
      Utils.replaceElementWithSpinner(
        document.querySelector('.popoveravailabilities .popover__content'),
      );
      this.setState({
        popOverCancelDisabled: 'disabled',
        popOverRequestDisabled: 'disabled',
      });
      if(this.state.requestError) {
        EmployeeActions.requestShiftWithConflict(this.selectedShiftID);
      } else {
        EmployeeActions.requestShift(this.selectedShiftID);
      }
      }
    }

  onCancelRequestClicked(e) {
    let id = this.selectedReplyShiftID;
    if (id == null) {
      id = this.selectedShiftID;
    }

    if (id != null) {
      Utils.replaceElementWithSpinner(
        document.querySelector('.popoveravailabilities .popover__content'),
      );
      this.setState({
        popOverCancelDisabled: 'disabled',
        popOverRequestDisabled: 'disabled',
      });
      EmployeeActions.cancelRequestedShift(id, this.selectedShiftID);
    }
  }

  onCancelClicked(e) {
    setTimeout(() => {
      this.setState({
        popOverRequestDisabled: '',
        popOverCancelDisabled: '',
        selectedDepartmentID: null,
        selectedLocationID: null,
        selectedPosition: null,
        selectedJobSiteName: null,
        selectedJobSiteAddress: null,
        notes: null,
        shift_breaks: null,
        popOverActive: false,
        popTarget: null,
        requestError: false,
      });
      this.resetPopover();
    }, 100);
  }

  onAvailabilitiesDetailClick(e, shiftID) {
    const that = this;
    const target = e.target || that.state.popTarget;
    if (target) {
      that.selectedTarget = target;
    }

    const el = document.querySelector('.popoveravailabilities');
    el.setAttribute('data-shift-replied', 'false');
    el.classList.remove('replied-shift');

    this.selectedShiftID = shiftID;
    const data = OffersStore.getAvailableShiftByID(shiftID);
    const reply_id = data.available_shift_reply_id;
    this.setState({
      hasReplies: !!data.replied,
      declined: !!data.declined,
      callOut: !!data.call_out,
      reply_id,
      currentlySelectedShiftId: shiftID,
    });

    const deptID = data.department_id;
    let breaks;
    if (!Utils.isNotDefined(data.breaks)) {
      breaks = Utils.formatUnformattedBreaks(data.breaks);
    }

    setTimeout(() => {
      that.setState({
        popOverActive: !that.state.popOverActive,
        popTarget: target,
        selectedDepartmentID: data.department_id,
        selectedLocationID: data.location_id,
        selectedPosition: data.position,
        selectedJobSiteName: data.job_site_name,
        selectedJobSiteAddress: data.job_site_address,
        notes: data.shift_notes,
        shift_breaks: breaks,
        popoverData: {
          title: !Utils.isNotDefined(data.name) ? data.name : '',
          time: `${moment(data.start_time)
            .tz(data.time_zone)
            .format('h:mm a')} – ${
            !data.hide_end_time
              ? moment(data.end_time)
                .tz(data.time_zone)
                .format('h:mm a')
              : this.props.t('SidebarAvailableShifts.tbd')
          }`,
        },
      });
    }, 100);
    this.selectedReplyShiftID = data.available_shift_reply_id;

    OffersStore.on('offer:reply:success', this.onShiftOfferSentSuccessfully);
    OffersStore.on('offer:cancel:success', this.onShiftOfferCanceledSuccessfully);
    OffersStore.on('offer:decline:success', this.onShiftOfferDeclinedSuccessfully);
    OffersStore.on('offer:reply:error offer:cancel:error offer:decline:error', this.onShiftOfferSentError);

    // e.stopPropagation();
  }

  render() {
    const len = this.props.shiftData ? this.props.shiftData.length : 0;
    const offers = [];
    const popOverCancelDisabled = this.state.popOverCancelDisabled || '';
    if (len > 0) {
      this.props.shiftData.sort(
        (a, b) => parseFloat(moment(a.start_time).unix()) - parseFloat(moment(b.start_time).unix()),
      );
      for (let i = 0; i < len; i++) {
        const startTime = moment(this.props.shiftData[i].start_time)
          .tz(this.props.shiftData[i].time_zone)
          .format('h:mm a');
        const endTime = moment(this.props.shiftData[i].end_time)
          .tz(this.props.shiftData[i].time_zone)
          .format('h:mm a');
        const hideEnd = this.props.shiftData[i].hide_end_time;
        offers.push(
          <SidebarAvailableShiftLink
            selectedShift={this.props.selectedShift}
            shiftID={this.props.shiftData[i].id}
            key={this.props.shiftData[i].id}
            startTime={startTime}
            endTime={!hideEnd ? endTime : this.props.t('SidebarAvailableShifts.tbd')}
            replied={this.props.shiftData[i].replied}
            onClickHandler={this.onAvailabilitiesDetailClick.bind(this)}
          />,
        );
      }
    }
    const classes = `calendar-input available-shifts ${!this.props.active ? 'hide' : ''}`;
    const { hasReplies, declined, popOverActive } = this.state;
    let popoverLabel = this.props.t('SidebarAvailableShifts.request_available_shift');
    if (hasReplies) {
      popoverLabel = this.props.t('SidebarAvailableShifts.cancel_requested_shift');
    } else if (declined) {
      popoverLabel = this.props.t('SidebarAvailableShifts.declined_shift');
    }
    return (
      <div>
        {popOverActive && <Backdrop onClick={this.onCancelClicked} />}
        <div className={classes}>
          <span className="calendar-input-bullet available-bullet">{this.props.t('SidebarAvailableShifts.available_shifts')}</span>
          <div className="data-list shifts">
            <ul>{offers}</ul>
          </div>
        </div>
        <Popover
          clearSelectedShiftId={this.props.clearSelectedShiftId}
          onHide={e => this._onClosePopover(e)}
          position="right"
          className="popoveravailabilities"
          active={popOverActive}
          popTarget={this.state.popTarget}
        >
          <h3>{popoverLabel}</h3>
          <p className="available-shift-detail-title">
            {this.state.popoverData.title}
            <br />
            {this.state.popoverData.time}
          </p>
          {!Utils.isNotDefined(this.state.shift_breaks) && (
            <p className="available-shift-detail-breaks">
              {this.props.t('SidebarAvailableShifts.breaks')}:&nbsp;
              {this.state.shift_breaks}
            </p>
          )}
          <span className="available-shift-detail-block">
            <ShiftDetailBlock
              locationID={this.state.selectedLocationID}
              departmentID={this.state.selectedDepartmentID}
              position={this.state.selectedPosition}
              job_site_name={this.state.selectedJobSiteName}
              job_site_address={this.state.selectedJobSiteAddress}
            />
          </span>
          {!Utils.isNotDefined(this.state.notes) && (
            <div className="available-shift-detail-notes-container">
              <p className="available-shift-detail-title">{this.props.t('SidebarAvailableShifts.notes').toUpperCase()}</p>
              <p className="available-shift-detail-notes">{this.state.notes}</p>
            </div>
          )}
          <p id="error-text" />
          <div className="btn-group pull--right">
            {!this.state.requestError ? (
              <button
                className="button button--inline available-request-cancel-button"
                onClick={this.onCancelClicked}
              >
                {this.props.t('SidebarAvailableShifts.close')}
              </button>
            ) : (
              <button
                className="button button--inline available-request-cancel-button"
                onClick={this.onCancelClicked}
              >
                {this.props.t('ConfirmationModal.cancel')}
              </button>
            )}
            {!hasReplies && !declined && !this.state.requestError && this.canDecline() && (
              <OfflineTooltip>
                <button
                  type="button"
                  className="button button--inline available-decline-button"
                  onClick={this.onDeclineClicked}
                  disabled={popOverCancelDisabled || !Utils.isOnline()}
                >
                  {this.props.t('SidebarAvailableShifts.decline')}
                </button>
              </OfflineTooltip>
            )}
            {!hasReplies && (
              <OfflineTooltip>
                <button
                  className="button button--recommended button--inline available-request-button"
                  onClick={this.onRequestClicked}
                  disabled={!Utils.isOnline()}
                >
                  {this.props.t('SidebarAvailableShifts.request')}
                </button>
              </OfflineTooltip>
            )}
            {hasReplies && (
              <OfflineTooltip>
                <button
                  disabled={popOverCancelDisabled || !Utils.isOnline()}
                  className="button button--recommended button--inline available-cancel-request-button"
                  onClick={this.onCancelRequestClicked}
                >
                  {this.props.t('SidebarAvailableShifts.cancel_request')}
                </button>
              </OfflineTooltip>
            )}
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(SidebarAvailableShifts);
